import React, { useEffect, useState } from "react";
import { DELETE_ALL } from "../text-data";
import { ReloadBlackSvg } from "./Assets";

const DEFAULT_MIN_HEIGHT = 200; // Adjust as needed

function CountableTextArea({
  defaultValue,
  textAreaRef,
  onChange,
  onClear,
  placeholder = "",
  maxLength = 1000,
}) {
  const [text, setText] = useState(defaultValue || "");
  const [isScroll, setScroll] = useState(false);
  // const textAreaRef = ref;
  const handleChange = (event) => {
    setText(event.target.value);
    onChange && onChange(event.target.value);
  };
  const clearText = () => {
    setText("");
  };
  const handleClear = () => {
    if (onClear) {
      onClear({ clearText });
      return;
    }
    clearText();
  };

  const calculateHeight = () => {
    if (textAreaRef.current) {
      // const computedStyle = window.getComputedStyle(textAreaRef.current);
      // const lineHeight = parseInt(computedStyle.lineHeight, 10);
      // const numberOfLines = textAreaRef.current.value.split("\n").length;
      // const padding =
      //   parseInt(computedStyle.paddingTop, 10) +
      //   parseInt(computedStyle.paddingBottom, 10);
      // const border =
      //   parseInt(computedStyle.borderTopWidth, 10) +
      //   parseInt(computedStyle.borderBottomWidth, 10);
      // const newHeight = Math.max(
      //   DEFAULT_MIN_HEIGHT,
      //   lineHeight * numberOfLines + padding + border
      // ); // Ensure minimum height
      // textAreaRef.current.style.height = `${newHeight}px`;
      setScroll(
        textAreaRef.current.scrollHeight > textAreaRef.current.clientHeight
      );
    }
  };

  useEffect(() => {
    calculateHeight();
  }, [text]); // Re-calculate height on text change

  const characterCount = text.length;
  // const remainingChars = maxLength - characterCount;

  return (
    <div className={isScroll ? "w-full blur-top" : "w-full"}>
      <textarea
        ref={textAreaRef}
        value={text}
        onChange={handleChange}
        style={{
          border: "none",
          paddingTop: 10,
          width: "100%",
          resize: "none",
          height: DEFAULT_MIN_HEIGHT,
        }}
        placeholder={placeholder}
        onInput={calculateHeight}
      />
      <div className="flex justify-between mt-6">
        <button className="flex items-center gap-0.5" onClick={handleClear}>
          <img className="w-3.5 h-3.5" src={ReloadBlackSvg}></img>
          <b className="text-xs">{DELETE_ALL}</b>
        </button>
        <span className="text-xs">
          <b
            className={
              characterCount > maxLength ? "text-red" : "text-darkblue"
            }
          >
            {characterCount}
          </b>
          <span style={{ color: "#B7BDCA" }}>/{maxLength}</span>
        </span>
      </div>
    </div>
  );
}

export default CountableTextArea;
